import Vue from 'vue'
import AccountConfigRepository from '../../model/AccountConfigRepository'
import ProductRepository from '../../model/ProductRepository'

import SelectableGrid from '../../components/SelectableGrid.vue'
import SelectableGridRow from '../../components/SelectableGridRow.vue'
import SelectableGridCell from '../../components/SelectableGridCell.vue'

export default {
  name: 'ProductSelectPartialView',

  props: {
    id: String,
    regionId: {
      type: Number
    },
    maxCustomerGroupId: {
      type: Number
    },
    shown: Boolean,
    startDate: String,
    endDate: String
  },

  data () {
    return {
      loading: false,
      searchDone: false,
      searchTerm: null,
      gridFocused: true,
      products: []
    }
  },

  watch: {
    maxCustomerGroupId () {
      this.productRepository.setMaxCustomerGroupId(this.maxCustomerGroupId)
    }
  },

  components: {
    'selectable-grid': SelectableGrid,
    'selectable-grid-row': SelectableGridRow,
    'selectable-grid-cell': SelectableGridCell
  },

  methods: {
    fetchProducts () {
      this.products = []
      this.loading = true
      this.gridFocused = false

      return this.productRepository.findProductWithBasePricesAndCost(this.searchTerm, this.regionId, this.startDate, this.endDate)
        .then(products => {
          this.products = products
          this.loading = false
          this.searchDone = true
          Vue.nextTick(() => {
            this.gridFocused = true
          })
        })
        .catch(error => {
          this.loading = false
          this.$reportError(error)
        })
    },

    hide () {
      this.$emit('hide')
      this.$emit('focus-lost')
    },

    reset () {
      this.$emit('focus-gained')

      this.searchDone = false
      this.searchTerm = ''
      this.products = []
      setTimeout(() => this.$refs.searchTermContainer.childNodes[0].focus(), 500)
    },

    selectProduct (product) {
      this.$emit('change', product)
      this.reset()
    }
  },

  created () {
    this.accountConfigRepository = new AccountConfigRepository(this.$api)
    this.productRepository = new ProductRepository(this.$api)
    this.productRepository.setMaxCustomerGroupId(this.maxCustomerGroupId)
  }
}



// WEBPACK FOOTER //
// ./src/views/EditEvent/ProductSelect.js